module.exports = __webpack_public_path__ + "img/lieferando.acb07c45.png";